export function setTransformToPreventOverflow(el) {
    d3.select(el).style('transform', null);

    // Move left if we overflow to the right
    const translateLeft = (el.getBoundingClientRect().x + el.getBoundingClientRect().width)
        - (el.ownerSVGElement.getBoundingClientRect().x + el.ownerSVGElement.getBoundingClientRect().width);
    if (translateLeft > 0) d3.select(el).style('transform', `translateX(${-translateLeft}px)`);

    // Move right if we overflow to the left
    const translateRight = el.ownerSVGElement.getBoundingClientRect().x - el.getBoundingClientRect().x;
    if (translateRight > 0) d3.select(el).style('transform', `translateX(${translateRight}px)`);
}
